import { investorByID, investorCreate, investorDestroy, investorList, investorUpdate } from '@/services/ventures/investors.service'

export default {
	namespaced: true,
	state: {
		investorList: { meta: { pagination: { total: 0 } } },
		investor: {},
		investorStatus: 'pending',
		investorSaveStatus: 'init',
		investorDeleteStatus: 'init',
	},
	getters: {
		getInvestorList: s => s.investorList,
		getInvestor: s => s.investor,
		getInvestorStatus: s => s.investorStatus,
		getInvestorSaveStatus: s => s.investorSaveStatus,
		getInvestorDeleteStatus: s => s.investorDeleteStatus,
	},
	mutations: {
		INVESTOR_LIST(state, value) { state.investorList = value },
		SET_INVESTOR(state, value) { state.investor = value },
		INVESTOR_STATUS(state, value) { state.investorStatus = value },
		INVESTOR_SAVE_STATUS(state, value) { state.investorSaveStatus = value },
		INVESTOR_DELETE_STATUS(state, value) { state.investorDeleteStatus = value },
	},
	actions: {
		async fetchInvestorList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('INVESTOR_STATUS', 'pending')
			commit('INVESTOR_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await investorList(params)
				commit('INVESTOR_STATUS', 'init')
				commit('INVESTOR_LIST', data)
				return data
			} catch (error) {
				commit('INVESTOR_STATUS', 'init')
				throw error
			}
		},
		async saveInvestor({ commit }, params) {
			commit('INVESTOR_SAVE_STATUS', 'pending')
			try {
				const { data } = await investorCreate(params)
				commit('INVESTOR_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INVESTOR_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateInvestor({ commit }, params) {
			commit('INVESTOR_SAVE_STATUS', 'pending')
			try {
				const { data } = await investorUpdate(params)
				commit('INVESTOR_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INVESTOR_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteInvestorByID({ commit }, params) {
			commit('INVESTOR_DELETE_STATUS', 'pending')
			try {
				const { data } = await investorDestroy(params)
				commit('INVESTOR_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INVESTOR_DELETE_STATUS', 'error')
				return error
			}
		},
	},
}
